import { equipmentFieldForDisplayTranslation } from "@/common/constants/equipmentFieldForDisplay.constant";
import { EquipmentData } from "../types/equipments.type";

export class EquipmentsTransformer {

  static optionsTransformer() {
    return (equipments: EquipmentData[]) => {
      return equipments.map((equipment) => {
        return {
          value: equipment.id,
          label: `${equipment[equipment.model?.category?.field_for_display as keyof EquipmentData] || equipment.license_plate || equipment.official_name} ${equipment.model ? `(${equipment.model?.display_name})` : ''}`,
        };
      });
    };
  }

  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      return Object.entries(errors).map(([key, value]) => {
        if (key in equipmentFieldForDisplayTranslation) {
          key = equipmentFieldForDisplayTranslation[key as keyof typeof equipmentFieldForDisplayTranslation];

          return {
            ['_base']: `${key} ${value.join(', ')}`,
          };
        }

        return {
          [key]: value.join(', '),
        }
      });
    };
  }

  static quickSearchModelTransformer() {
    return (equipments: EquipmentData[]) => {
      return equipments.map((equipment) => ({
        route: `/equipments/${equipment.id}`,
        items: [
          [equipment.license_plate ? 'Placa' : 'Nome', equipment.license_plate || equipment.official_name],
          ['Marca', equipment.model?.brand],
          ['Modelo', `${equipment.model?.display_name} ${equipment.model?.year}`],
        ],
      }));
    };
  }

}
